var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823_960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_823_960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 17.3C14.3134 17.6866 13.6866 17.6866 13.3 17.3L8.70711 12.7071C8.31658 12.3166 8.31658 11.6834 8.70711 11.2929L13.3 6.7C13.6866 6.3134 14.3134 6.3134 14.7 6.7C15.0866 7.0866 15.0866 7.7134 14.7 8.1L11.5071 11.2929C11.1166 11.6834 11.1166 12.3166 11.5071 12.7071L14.7 15.9C15.0866 16.2866 15.0866 16.9134 14.7 17.3Z",
    fill: "#FB7C2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.6bacd4c65605a7bb978a1f7a873e5eb3.svg";
export { ForwardRef as ReactComponent };